import { SET_SELECTED_DOCUMENT } from '../actionTypes';
import { reportTemplateActions } from '../reducer';

export default (values) => reportTemplateActions[SET_SELECTED_DOCUMENT](values);
